import type { CalculatorData } from "../types/calculatorData";
import { applyCalculatorRadioChange } from "./applyCalculatorRadioChange";

export interface CalculatorUrlParams {
  Period?: string | number;
  Ows?: string | number;
  Mileages?: string | number;
  Rvs?: string | number;
  FinancingMethod?: string | number;
}

/** Applies URL param selections to calculator tree via existing radio-change logic. */
export function applyUrlParamsToCalculatorData(
  calculatorData: CalculatorData,
  urlParams: CalculatorUrlParams
): CalculatorData {
  const cloned: CalculatorData = JSON.parse(JSON.stringify(calculatorData));
  const financingMethod = Number(urlParams.FinancingMethod);

  if (financingMethod === 1) {
    if (urlParams.Period != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LongTimeRentCalculatorValuesDTO",
        RadioName: "Periods",
        Value: Number(urlParams.Period),
        Status: true
      });
    }
    if (urlParams.Ows != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LongTimeRentCalculatorValuesDTO",
        RadioName: "Ows",
        Value: Number(urlParams.Ows),
        Status: true
      });
    }
    if (urlParams.Mileages != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LongTimeRentCalculatorValuesDTO",
        RadioName: "Mileages",
        Value: Number(urlParams.Mileages),
        Status: true
      });
    }
  } else if (financingMethod === 2) {
    if (urlParams.Period != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LeasingCalculatorValues",
        RadioName: "Periods",
        Value: Number(urlParams.Period),
        Status: true
      });
    }
    if (urlParams.Ows != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LeasingCalculatorValues",
        RadioName: "Ows",
        Value: Number(urlParams.Ows),
        Status: true
      });
    }
    if (urlParams.Rvs != null) {
      applyCalculatorRadioChange(cloned, {
        Parent: "LeasingCalculatorValues",
        RadioName: "Rvs",
        Value: Number(urlParams.Rvs),
        Status: true
      });
    }
  }

  return cloned;
}
